import { useMemo } from 'react';
import type { Tables } from '@/integrations/supabase/types';

type TimeEntry = Tables<'time_entries'>;

interface ProjectTimeStats {
  totalHours: number;
  billableHours: number;
  nonBillableHours: number;
  billableValue: number;
  nonBillableValue: number;
}

/**
 * Calcula estatísticas de tempo de um projeto separando horas faturáveis e não faturáveis
 */
export function useProjectTimeStats(
  timeEntries: (TimeEntry & { projects?: any })[] | undefined,
  projectId: string,
  fallbackHourlyRate: number = 0
): ProjectTimeStats {
  return useMemo(() => {
    const projectEntries = timeEntries?.filter((entry) => entry.project_id === projectId) || [];

    let totalMinutes = 0;
    let billableMinutes = 0;
    let nonBillableMinutes = 0;
    let billableValue = 0;
    let nonBillableValue = 0;

    projectEntries.forEach((entry) => {
      const minutes = entry.duration_minutes || 0;
      const rate = entry.hourly_rate || fallbackHourlyRate;
      const hours = minutes / 60;

      totalMinutes += minutes;

      if (entry.is_billable !== false) {
        billableMinutes += minutes;
        billableValue += hours * rate;
      } else {
        nonBillableMinutes += minutes;
        // Não faturável = valor 0
      }
    });

    return {
      totalHours: Math.round((totalMinutes / 60) * 100) / 100,
      billableHours: Math.round((billableMinutes / 60) * 100) / 100,
      nonBillableHours: Math.round((nonBillableMinutes / 60) * 100) / 100,
      billableValue: Math.round(billableValue * 100) / 100,
      nonBillableValue: 0,
    };
  }, [timeEntries, projectId, fallbackHourlyRate]);
}
